module.exports = "<div class=bc-tag-list ng-transclude></div> ";